module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-879.71222a00.jpg";